import s from "./style.module.css";

<rich-text paddingBlock=["xl", "xl"] class=s.text>
    <@headline>
        We empower the world’s largest community of enthusiasts to do more of
        what they love
    </@headline>
</rich-text>
